const typeMarkup = (pokemon) =>
  pokemon.typeLabels
    .map(
      (label, index) =>
        `<span class="type-pill type-pill--${pokemon.types[index]}">${label}</span>`,
    )
    .join('');

export const pokemonCard = (pokemon, index) => `
  <button
    class="pokemon-card"
    type="button"
    data-pokemon-slug="${pokemon.slug}"
    style="--accent: ${pokemon.accent}; --delay: ${Math.min(index, 12) * 45}ms"
    aria-label="Ver ficha de ${pokemon.name}"
  >
    <span class="pokemon-card__corners" aria-hidden="true"></span>
    <span class="pokemon-card__energy" aria-hidden="true"></span>
    <span class="pokemon-card__number">#${String(pokemon.number).padStart(4, '0')}</span>
    <span class="pokemon-card__image-wrap">
      <img src="${pokemon.image}" alt="${pokemon.name}" loading="lazy" width="280" height="280" />
    </span>
    <span class="pokemon-card__content">
      <strong>${pokemon.name}</strong>
      <span class="pokemon-card__types">${typeMarkup(pokemon)}</span>
    </span>
    <span class="pokemon-card__action" aria-hidden="true">Ver ficha <b>↗</b></span>
  </button>
`;

export const featuredCard = (pokemon, index) => `
  <button
    class="featured-card featured-card--${index + 1}"
    type="button"
    data-pokemon-slug="${pokemon.slug}"
    style="--accent: ${pokemon.accent}"
    aria-label="Descubrir a ${pokemon.name}"
  >
    <span class="featured-card__index">0${index + 1}</span>
    <span class="featured-card__glow" aria-hidden="true"></span>
    <img src="${pokemon.image}" alt="${pokemon.name}" width="360" height="360" />
    <span class="featured-card__copy">
      <small>${pokemon.typeLabels.join(' · ')}</small>
      <strong>${pokemon.name}</strong>
      <span>Descubrir <b aria-hidden="true">→</b></span>
    </span>
  </button>
`;
